import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

export enum GetDraftArticleByIdQueryCacheKey {
  GetDraftArticleByIdQuery = 'GetDraftArticleByIdQuery',
}

export const useGetDraftArticleByIdQuery = (
  draftId: number,
  enabled: boolean,
) => {
  const { getDraftArticleById } = useServicesContext();
  return useQuery({
    queryKey: [
      GetDraftArticleByIdQueryCacheKey.GetDraftArticleByIdQuery,
      draftId,
    ],
    queryFn: () => getDraftArticleById({ draftId }),
    refetchOnMount: enabled,
    enabled,
  });
};
